import Image from "next/image";
import { FC } from "react";

const PartnersBadge: FC = (): JSX.Element => {
  return (
    <div className="flex flex-row md:flex-col md:items-center lg:flex-row">
      <div className="rounded-full relative flex w-16 h-16  md:mb-2.5">
        <Image
          src="/cutomers-reviews/customer-female.png"
          alt="Customer Image"
          objectFit="contain"
          priority
          layout="fill"
        />
      </div>
      <div className="flex flex-col text-lg font-bold justify-center ml-8 md:ml-auto lg:ml-8 md:mb-2.5">
        <span>Elizabeth, Sales Progression</span>
        <span>Dartford</span>
      </div>
    </div>
  );
};

export default PartnersBadge;
